var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.online())?_c('v-btn',{attrs:{"icon":_vm.icon,"title":"Imprimir Pedido","rounded":_vm.rounded},on:{"click":function($event){return _vm.imprimirPedido()}}},[_c('v-icon',{attrs:{"left":!_vm.icon}},[_vm._v("mdi-printer-outline")]),_vm._v(" "),(!_vm.icon)?_c('span',[_vm._v("Imprimir Pedido")]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }